import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import TRANSLATIONS_PL from './pl/translations';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pl: {
        translation: TRANSLATIONS_PL,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
